import * as React from "react";
const SvgPlaySimple = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M8 5v14l11-7z" /><path fill="none" d="M0 0h24v24H0z" /></svg>;
export { SvgPlaySimple as ReactComponent };